import React from "react";
import { useSubmit, useNavigation, useActionData } from "react-router";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Card, Button, Form, FloatingLabel } from "react-bootstrap";
import BackLink from "./BackLink";
import { EmailSignupSchema } from "schema/account";
import { renderLoadingProgressToast } from "components/shared/Toasts";
import axios from "axios";

export async function action({ request }) {
    const data = await request.json();
    // Prepare HTTP Basic Auth header
    const basicAuth = btoa(`${data.email}:${data.password}`);
    var result = await renderLoadingProgressToast(
        axios.post(
            "account/register",
            {}, // No body needed for basic auth
            {
                headers: {
                    Authorization: `Basic ${basicAuth}`,
                },
            }
        )
    )
        .then(() => ({ success: true }))
        .catch((error) => {
            if (error.response?.data) {
                var data = error.response?.data;
                return Promise.resolve({
                    success: false,
                    reason: data["description"],
                });
            }
            return Promise.reject(error);
        });
    if (result.success === true) {
        window.location.replace("/");
        return null;
    }
    return result;
}

const SignUp = () => {
    const submit = useSubmit();
    const actionData = useActionData();
    const navigation = useNavigation();
    const isNavigating =
        navigation.state === "submitting" || navigation.state === "loading";

    const onSignUp = async (data) => {
        await submit(data, {
            action: "/account/signup",
            method: "post",
            encType: "application/json",
        });
    };

    const onError = (errors, e) => console.error(errors, e);

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(EmailSignupSchema),
    });

    return (
        <div style={{ width: "100%", maxWidth: "350px", margin: "0 auto" }}>
            <BackLink />
            <Card className="mt-3" style={{ width: "100%" }} border="secondary">
                <Card.Header>Sign Up</Card.Header>
                <Card.Body>
                    <Form
                        onSubmit={handleSubmit(onSignUp, onError)}
                        onReset={reset}
                    >
                        <Form.Group className="mb-3">
                            <Controller
                                control={control}
                                name="email"
                                render={({
                                    field: { onChange, value, ref },
                                }) => (
                                    <FloatingLabel
                                        controlId="email"
                                        label="Email"
                                    >
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            isInvalid={errors.email}
                                            placeholder="Email"
                                            onChange={onChange}
                                            value={value}
                                            ref={ref}
                                            rules={{ required: true }}
                                            data-testid="input_email"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.email?.message}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                )}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Controller
                                control={control}
                                name="password"
                                render={({
                                    field: { onChange, value, ref },
                                }) => (
                                    <FloatingLabel
                                        controlId="password"
                                        label="Password"
                                    >
                                        <Form.Control
                                            type="password"
                                            name="password"
                                            isInvalid={errors.password}
                                            placeholder="Password"
                                            onChange={onChange}
                                            value={value}
                                            ref={ref}
                                            rules={{ required: true }}
                                            data-testid="input_password"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.password?.message}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                )}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Controller
                                control={control}
                                name="confirm_password"
                                render={({
                                    field: { onChange, value, ref },
                                }) => (
                                    <FloatingLabel
                                        controlId="confirm_password"
                                        label="Confirm Password"
                                    >
                                        <Form.Control
                                            type="password"
                                            name="confirm_password"
                                            isInvalid={errors.confirm_password}
                                            placeholder="Enter password again"
                                            onChange={onChange}
                                            value={value}
                                            ref={ref}
                                            rules={{ required: true }}
                                            data-testid="input_confirm_password"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.confirm_password?.message}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                )}
                            />
                        </Form.Group>
                        {actionData?.reason && (
                            <div className="text-danger mb-3">
                                {actionData.reason}
                            </div>
                        )}
                        <div className="d-grid gap-2">
                            <Button
                                type="submit"
                                variant="primary"
                                disabled={isNavigating}
                            >
                                Sign Up
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default SignUp;
